export default __webpack_public_path__ + "static/media/black-chair.ae677f8f.jpeg";